import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * AuthGuard — Redirects authenticated users away from signup/login pages.
 *
 * Props:
 *   children  — The page to render if the user is NOT authenticated
 *
 * Redirect logic:
 *   - Company user → /company/matches
 *   - Engineer user → /
 *   - Not authenticated → render children
 */
export default function AuthGuard({ children }) {
    const { user, isAuthenticated, loading } = useAuth();

    // Don't redirect while still loading auth state
    if (loading) return null;

    if (isAuthenticated) {
        if (user?.role === "company") {
            return <Navigate to="/company/matches" replace />;
        }
        return <Navigate to="/" replace />;
    }

    return children;
}
